import { CommonSearchInput } from 'components/common/form/search';
import { compact, uniq } from 'lodash';
import { useMemo } from 'react';
import { useVideosStore } from 'stores/use-videos-store';

interface IProps {
  onChange?: () => void;
}

export const VideosFilterTeamName = (props: IProps) => {
  const filter = useVideosStore((s) => s.filter);
  const videos = useVideosStore((s) => s.videos);

  const options = useMemo(() => {
    return compact(uniq(videos.map((o) => o.TeamName?.trim()))).map((o) => ({
      label: o,
      value: o,
    }));
  }, [videos]);

  return (
    <CommonSearchInput
      id="video-team"
      placeholder="common.teams"
      options={options}
      values={filter.teamName}
      onChange={(v) => {
        useVideosStore.getState().mergeFilter({ teamName: v });
        props.onChange?.();
      }}
      multiple
      optional
    />
  );
};
